import {
  IconSvg,
  extendableComponent,
  iconChevronLeft,
  iconChevronRight,
} from '@graphcommerce/next-ui'
import { Trans } from '@lingui/react'
import { IconButton, Box } from '@mui/material'
import { usePagination } from 'react-instantsearch-hooks-web'

export function AlgoliaPagination() {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { nbPages, refine, currentRefinement } = usePagination()
  const parts = ['root', 'button', 'icon'] as const
  const { classes } = extendableComponent('Pagination', parts)

  const chevronLeft = (
    <IconButton
      size='medium'
      disabled={currentRefinement === 0}
      color='inherit'
      aria-label='Previous page'
      className={classes.button}
    >
      <IconSvg src={iconChevronLeft} className={classes.icon} size='medium' />
    </IconButton>
  )

  const chevronRight = (
    <IconButton
      size='medium'
      disabled={currentRefinement === nbPages}
      color='inherit'
      aria-label='Next page'
      className={classes.button}
    >
      <IconSvg src={iconChevronRight} className={classes.icon} size='medium' />
    </IconButton>
  )

  const renderLink = (page, icon) => (
    <Box
      onClick={() => {
        refine(page as number)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }}
    >
      {icon}
    </Box>
  )

  return (
    <Box
      className={classes.root}
      sx={(theme) => ({
        margin: '0 auto',
        marginTop: theme.spacings.lg,
        marginBottom: theme.spacings.lg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        '& .Mui-disabled': {
          background: 'none',
        },
      })}
    >
      {currentRefinement === 0 ? chevronLeft : renderLink(currentRefinement - 1, chevronLeft)}

      <Box typography='body1'>
        <Trans
          id='Page {page} of {count}'
          values={{ page: currentRefinement + 1, count: Math.max(1, nbPages) }}
        />
      </Box>

      {currentRefinement === nbPages
        ? chevronRight
        : renderLink(currentRefinement + 1, chevronRight)}
    </Box>
  )
}
